import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
function handleSingleDateCalendarChange(setValue, watchLabel, setDefaultMonth, date) {
    const formattedDate = format(date, 'yyyyMMdd');
    setValue(watchLabel, formattedDate);
    setDefaultMonth(date);
}
function handleDateRangeCalendarChange(setValue, watchStartLabel, watchEndLabel, setDefaultMonth, dates) {
    if (dates?.from) {
        const startDate = format(dates.from, 'yyyyMMdd');
        setValue(watchStartLabel, startDate);
        setDefaultMonth(dates.from);
        setValue(watchEndLabel, '');
    }
    if (dates?.to) {
        const endDate = format(dates.to, 'yyyyMMdd');
        setValue(watchEndLabel, endDate);
    }
}
const isString = (value)=>'string' == typeof value;
function getPartStaySelectedDates(watchHotelStartDate, watchHotelEndDate, watchStartDate, watchEndDate) {
    if (watchHotelStartDate) return {
        from: parse(watchHotelStartDate, 'yyyyMMdd', new Date()),
        to: watchHotelEndDate ? parse(watchHotelEndDate, 'yyyyMMdd', new Date()) : void 0
    };
    return {
        from: watchStartDate ? parse(watchStartDate, 'yyyyMMdd', new Date()) : void 0,
        to: watchEndDate ? parse(watchEndDate, 'yyyyMMdd', new Date()) : void 0
    };
}
export { getPartStaySelectedDates, handleDateRangeCalendarChange, handleSingleDateCalendarChange, isString };
